import { useState } from 'react';
import { useTranslationQuery } from '../queries/useTranslationQuery';
import { useTranslationEditor } from './TranslationEditorContext';

export function useTranslationDrawer() {
    const editor = useTranslationEditor();
    const [failureMessage, setFailureMessage] = useState<string | null>(null);
    const translation = useTranslationQuery(editor.selectedKey);

    function dismissFailure() {
        setFailureMessage(null);
    }

    function retryLoading() {
        translation.refetch();
    }

    return {
        ...editor,
        translation,
        retryLoading,
        failureMessage,
        reportFailure: setFailureMessage,
        dismissFailure
    };
}
